/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * A string that represents the type of user that sent a message.
 */
export var RoleType;
(function (RoleType) {
    RoleType["USER"] = "user";
    RoleType["AI_AGENT"] = "ai-agent";
    RoleType["LIVE_AGENT"] = "live-agent";
})(RoleType || (RoleType = {}));
